module.exports = __webpack_public_path__ + "static/img/2_8_2.2ff740c4.jpg";